module.exports = __webpack_public_path__ + "img/media_youtube.b980f948.svg";